import React from 'react';

interface QuickStatsProps {
  nutritionData: any;
  goalsData: any;
  todayData?: any;
  yesterdayData?: any;
}

export const QuickStats: React.FC<QuickStatsProps> = ({ 
  nutritionData, 
  goalsData,
  todayData,
  yesterdayData
}) => {
  // Create nutrition stat rows
  const createNutritionRow = (data: any, title: string, subtitle: string) => {
    return [
      {
        name: 'Calories',
        value: (data?.calories?.toFixed(0) || data?.average_per_day?.calories?.toFixed(0) || '0'),
        unit: 'kcal',
        change: subtitle,
        icon: '🔥',
      },
      {
        name: 'Protein',
        value: (data?.protein?.toFixed(1) || data?.average_per_day?.protein?.toFixed(1) || '0'),
        unit: 'g',
        change: subtitle,
        icon: '💪',
      },
      {
        name: 'Carbs',
        value: (data?.carbohydrates?.toFixed(1) || data?.average_per_day?.carbohydrates?.toFixed(1) || '0'),
        unit: 'g',
        change: subtitle,
        icon: '🌾',
      },
      {
        name: 'Fat',
        value: (data?.fat?.toFixed(1) || data?.average_per_day?.fat?.toFixed(1) || '0'),
        unit: 'g',
        change: subtitle,
        icon: '🥑',
      },
    ];
  };

  const todayStats = createNutritionRow(todayData, 'Today', `${todayData?.meal_count || 0} meals logged`);
  const yesterdayStats = createNutritionRow(yesterdayData, 'Yesterday', `${yesterdayData?.meal_count || 0} meals logged`);
  const weeklyStats = createNutritionRow(nutritionData, '7-Day Average', `${nutritionData?.meal_count || 0} total meals`);

  const StatRow = ({ stats, title, bgColor = 'bg-white' }: { stats: any[], title: string, bgColor?: string }) => (
    <div className="space-y-2">
      <h3 className="text-lg font-semibold text-gray-900 px-2">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((stat, index) => (
          <div key={index} className={`card ${bgColor}`}>
            <div className="card-body">
              <div className="flex items-center">
                <div className="flex-1">
                  <p className="text-sm font-medium text-gray-600">{stat.name}</p>
                  <div className="flex items-baseline">
                    <p className="text-2xl font-semibold text-gray-900">
                      {stat.value}
                    </p>
                    <p className="ml-1 text-sm text-gray-500">{stat.unit}</p>
                  </div>
                </div>
                <div className="text-2xl">{stat.icon}</div>
              </div>
              
              <div className="mt-3">
                <div className="flex items-center text-sm">
                  <span className="text-gray-600 font-medium">
                    {stat.change}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="space-y-8">
      {/* Today Stats */}
      {todayData && <StatRow stats={todayStats} title="Today" bgColor="bg-blue-50" />}

      {/* Yesterday Stats */}
      {yesterdayData && <StatRow stats={yesterdayStats} title="Yesterday" bgColor="bg-gray-50" />}

      {/* 7-Day Average Stats */}
      {nutritionData && <StatRow stats={weeklyStats} title="7-Day Average" bgColor="bg-white" />}
    </div>
  );
};